import React, { useCallback } from "react";
import { TextField } from '@mui/material'
import { SxProps } from "@mui/material";
import { Theme } from "@mui/material";

interface PercentageTextFieldProps {
    label: string;
    value?: string;
    sx?: SxProps<Theme>;
    onChange: (value: string) => void;
}

const PercentageTextField: React.FC<PercentageTextFieldProps> = ({ label, value = "", sx, onChange }) => {
    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = event.target.value.replace('%', '');

        if (inputValue === '') {
            onChange('');
            return;
        }

        let numberValue = parseFloat(inputValue);
        if (!isNaN(numberValue) && numberValue >= 0 && numberValue <= 100) {
            onChange(inputValue);
        }
    }, [onChange]);

    const handleBlur = useCallback(() => {
        if (value !== '' && !value.includes('%')) {
            onChange(value + '%');
        }
    }, [onChange, value]);

    const handleFocus = useCallback(() => {
        if (value.includes('%')) {
            onChange(value.replace('%', ''));
        }
    }, [onChange, value]);

    return (
        <TextField
            sx={sx}
            value={value}
            label={label}
            id={`percentage-text-field_${label}`}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            placeholder="0% - 100%"
            inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*"
            }}
        />
    );
};

export default PercentageTextField;